import { memo } from 'react';
import { HrBrick } from './HrBrick.jsx';
import { ButtonLink } from './ButtonLink.jsx';

const HouseIcon = () => (
  <svg
    viewBox="0 0 510 467"
    width="510"
    height="467"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M46.1 423.8h57.7M204.4 423.8H262M263.8 387.3h240.9M128.8 281.8h49.6c4.3 0 7.7 3.5 7.7 7.8V406h-65V289.6a7.8 7.8 0 0 1 7.7-7.8zM308.5 281.8h47.3c4.9 0 8.9 4 8.9 8.9v56.2h-65.1v-56.2c0-5 4-9 8.9-9zM411 281.8h49.2a8 8 0 0 1 8 8v57h-65v-57a8 8 0 0 1 7.9-8zM108.7 406.5h90.7a5 5 0 0 1 5 5v21.9H103.8v-22a5 5 0 0 1 5-4.9zM97.3 433.4h113.6a5.8 5.8 0 0 1 5.8 5.8v22.6H91.5v-22.6c0-3.2 2.6-5.8 5.8-5.8zM240.2 136.1h197c4.5 0 8.7 2.5 11 6.4l56.5 97.4M11.4 222.4c-11 17.1-6.1 40 11 51L153.5 70.5v-66L11.4 222.4z"
        stroke="var(--bgHotBlue__text)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M302.8 239.9c.9 13.4-5.6 26.2-16.9 33.5L264.1 240h-.5v183.9h230a11 11 0 0 0 11-11v-173H302.9z"
        stroke="var(--bgHotBlue__text)"
        strokeWidth="3"
      />
      <path
        d="M153.6 70.7L44.6 240v210.3c0 6.4 5.2 11.6 11.6 11.6H252a11.6 11.6 0 0 0 11.6-11.6V239.9l-110-169.2z"
        stroke="var(--bgHotBlue__text)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M302.8 239.9a36.6 36.6 0 0 0-5.8-17.5L153.5 4.4v66.2l110.6 169.3M332.1 281.8v63.6M130 174.8h47.3c4.9 0 8.9 4 8.9 8.9v56.2H121v-56.2a8.9 8.9 0 0 1 8.9-9zM153.6 174.8v63.6M435.7 281.8v65"
        stroke="var(--bgHotBlue__text)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M272.3 150.7c3.4 6 9.6 11.5 17 10.9 6.5-.6 11.8-6 11.7-12.6 0-1.9-3-1.9-3 0 .2 6.1-5.6 10.3-11.4 9.5-5.3-.7-9.2-4.8-11.7-9.2-1-1.7-3.5-.2-2.6 1.4z"
        fill="var(--bgHotBlue__text)"
      />
      <path
        d="M298.3 150.7c3.4 6 9.5 11.5 17 10.9 6.4-.6 11.8-6 11.6-12.6 0-1.9-3-1.9-3 0 .2 6.1-5.6 10.3-11.3 9.5-5.3-.7-9.3-4.8-11.8-9.2-.9-1.7-3.4-.2-2.5 1.4zM363.4 150.7c3.4 6 9.5 11.5 17 10.9 6.4-.6 11.8-6 11.6-12.6 0-1.9-3-1.9-3 0 .2 6.1-5.6 10.3-11.3 9.5-5.4-.7-9.3-4.8-11.8-9.2-.9-1.7-3.5-.2-2.5 1.4zM411.8 150.7c3.4 6 9.6 11.5 17 10.9 6.5-.6 11.8-6 11.7-12.6 0-1.9-3-1.9-3 0 .1 6.1-5.6 10.3-11.4 9.5-5.3-.7-9.2-4.8-11.7-9.2-1-1.7-3.5-.2-2.6 1.4zM288.5 173.6c3.4 6.1 9.6 11.5 17 10.9 6.5-.6 11.8-6 11.7-12.6 0-1.9-3-1.9-3 0 .1 6.1-5.6 10.3-11.4 9.5-5.3-.7-9.2-4.8-11.7-9.2-1-1.7-3.5-.2-2.6 1.4zM350.4 173.6c3.4 6.1 9.6 11.5 17 10.9 6.4-.6 11.8-6 11.7-12.6 0-1.9-3-1.9-3 0 .1 6.1-5.6 10.3-11.4 9.5-5.3-.7-9.3-4.8-11.7-9.2-1-1.7-3.5-.2-2.6 1.4z"
        fill="var(--bgHotBlue__text)"
      />
      <path
        d="M376.3 173.6c3.4 6.1 9.6 11.5 17 10.9 6.5-.6 11.8-6 11.7-12.6 0-1.9-3-1.9-3 0 .1 6.1-5.6 10.3-11.4 9.5-5.3-.7-9.2-4.8-11.7-9.2-1-1.7-3.5-.2-2.6 1.4zM417.2 195.4c3.3 6.1 9.5 11.5 17 10.9 6.4-.6 11.8-6 11.6-12.5 0-2-3-2-3 0 .2 6-5.6 10.2-11.4 9.4-5.3-.7-9.2-4.7-11.7-9.2-1-1.7-3.5-.2-2.5 1.5z"
        fill="var(--bgHotBlue__text)"
      />
      <path
        d="M391.2 195.4c3.4 6.1 9.6 11.5 17 10.9 6.5-.6 11.8-6 11.7-12.5 0-2-3-2-3 0 .1 6-5.6 10.2-11.4 9.4-5.3-.7-9.2-4.7-11.7-9.2-1-1.7-3.5-.2-2.6 1.5zM320 195.4c3.4 6.1 9.6 11.5 17 10.9 6.5-.6 11.8-6 11.7-12.5 0-2-3-2-3 0 .1 6-5.6 10.2-11.4 9.4-5.3-.7-9.2-4.7-11.7-9.2-1-1.7-3.5-.2-2.6 1.5zM350.4 218.1c3.4 6 9.6 11.5 17 10.9 6.4-.6 11.8-6 11.7-12.6 0-1.9-3-1.9-3 0 .1 6-5.6 10.2-11.4 9.5-5.3-.7-9.3-4.8-11.7-9.3-1-1.6-3.5-.1-2.6 1.5z"
        fill="var(--bgHotBlue__text)"
      />
      <path
        d="M376.3 218.1c3.4 6 9.6 11.5 17 10.9 6.5-.6 11.8-6 11.7-12.6 0-1.9-3-1.9-3 0 .1 6-5.6 10.2-11.4 9.5-5.3-.7-9.2-4.8-11.7-9.3-1-1.6-3.5-.1-2.6 1.5zM324.2 218.1c3.4 6 9.6 11.5 17 10.9 6.5-.6 11.8-6 11.7-12.6 0-1.9-3-1.9-3 0 .1 6-5.6 10.2-11.4 9.5-5.3-.7-9.2-4.8-11.7-9.3-1-1.6-3.5-.1-2.6 1.5z"
        fill="var(--bgHotBlue__text)"
      />
      <path
        d="M297 347h71.8a5 5 0 0 1 5 4.9v8.5H292v-8.5a5 5 0 0 1 5-5zM399.7 347h72a5 5 0 0 1 4.8 4.9v8.5h-81.7v-8.5a5 5 0 0 1 4.9-5zM117.6 239.9h71.9a5 5 0 0 1 4.9 5v8.4h-81.8v-8.5a5 5 0 0 1 5-5z"
        stroke="var(--bgHotBlue__text)"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle fill="var(--bgHotBlue__text)" cx="134.3" cy="353.3" r="6.4" />
    </g>
  </svg>
);

const CalculatorIcon = () => (
  <svg
    width="137"
    height="137"
    viewBox="0 0 137 137"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="var(--bgHotBlue__text)"
      strokeWidth="2"
    >
      <path d="M98.4 98.8c0 4-3.2 7.1-7.1 7.1H46.2c-4 0-7.1-3.2-7.1-7.1V39.3c0-4 3.2-7.1 7.1-7.1h45c4 0 7.2 3.2 7.2 7.1v59.5z" />
      <path d="M46.5 38.9H91v14.7H46.5zM80.2 58.3h9.9v10.3h-9.9zM80.2 73.6h9.9v25.7h-9.9zM63.4 58.3h9.9v10.3h-9.9zM46.5 58.3h9.9v10.3h-9.9zM63.4 73.6h9.9v10.3h-9.9zM46.5 73.6h9.9v10.3h-9.9zM63.4 88.9h9.9v10.3h-9.9zM46.5 88.9h9.9v10.3h-9.9z" />
    </g>
  </svg>
);

const InterestOverviewIcon = () => (
  <svg
    width="137"
    height="137"
    viewBox="0 0 137 137"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="var(--bgHotBlue__text)"
      strokeWidth="2"
    >
      <path d="M94.3 77.3v28.5H55.5L42.7 93V32.8h51.6v10.5" />
      <path d="M42.7 93h12.8v12.8zM105 79.4a2.8 2.8 0 0 1-4 0l-11-11a.5.5 0 0 1 0-.8l3.2-3.2c.3-.3.6-.3.8 0l11 11a2.8 2.8 0 0 1 0 4z" />
      <path d="M90.4 62.3l2.5 2.4-2.5 2.6-2.5-2.5" />
      <circle cx="79.8" cy="54.2" r="13.4" />
      <path d="M50.5 46.7h13.2M50.5 55.8h11.4M50.5 64.8h13.2M50.5 73.9h36M50.5 83h36M64.6 92h21.9M84 50l-8 8M77 50c0 .6-.4 1-1 1a1 1 0 0 1-1-1c0-.5.5-1 1-1 .6 0 1 .5 1 1zM84.5 57.6c0 .5-.4 1-1 1a1 1 0 0 1-1-1c0-.6.5-1 1-1 .6 0 1 .4 1 1z" />
    </g>
  </svg>
);

const MaginifyingClassIcon = () => (
  <svg
    width="137"
    height="137"
    viewBox="0 0 137 137"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="var(--bgHotBlue__text)"
      strokeWidth="2"
    >
      <path d="M40 50.1v17.3M47 44.3v23M54 50.4v17M60.9 55.9v11.5M67.8 50.4v17M74.8 61.2v6.2M104.2 101.4l-3.3 3.3a2.8 2.8 0 0 1-4 0L75.1 82.8a.5.5 0 0 1 0-.7l6.5-6.5c.2-.3.5-.3.7 0l21.9 21.8a2.8 2.8 0 0 1 0 4zM76.2 72.1l4.4 4.4-4.6 4.6-4.4-4.4" />
      <circle cx="56.9" cy="57.4" r="24.2" />
    </g>
  </svg>
);

export const BoliglaanPartial = memo(function BoliglaanPartial() {
  return (
    <div className="boliglaan">
      <div className="boliglaan__text">
        <h2>Best og billigst boliglån</h2>
        <HrBrick />
        <p>
          Skal du kjøpe ny bolig, eller ønsker du å få bedre rente på lånet du
          har i dag?
        </p>
        <p>
          Vi sammenligner den reelle boliglånsrenten mellom alle bankene i
          landet. Det er kun da du kan være trygg på at du får det beste lånet.
        </p>
        <p>
          <ButtonLink href="/boliglan">Ta testen!</ButtonLink>
        </p>
      </div>
      <div className="boliglaan__illustration">
        <HouseIcon />
      </div>
      <ul className="boliglaan__features">
        <li className="boliglaan__feature">
          <div className="boliglaan__featureIcon" role="presentation">
            <CalculatorIcon />
          </div>
          <div className="boliglaan__featureText">
            <h3>Spar penger</h3>
            <p>
              Banken gir ikke gullrenten til alle. Se hvor mye du kan spare om
              du får den.
            </p>
          </div>
        </li>
        <li className="boliglaan__feature">
          <div className="boliglaan__featureIcon" role="presentation">
            <InterestOverviewIcon />
          </div>
          <div className="boliglaan__featureText">
            <h3>Renteoversikt</h3>
            <p>
              Den reelle renten i markedet er skjult. Få oversikt med vår
              tjeneste.
            </p>
          </div>
        </li>
        <li className="boliglaan__feature">
          <div className="boliglaan__featureIcon" role="presentation">
            <MaginifyingClassIcon />
          </div>
          <div className="boliglaan__featureText">
            <h3>Detaljert statistikk</h3>
            <p>
              Vi vet hva som er en god rente i din bank og i din by. Ta testen
              og se.
            </p>
          </div>
        </li>
      </ul>

      <style jsx>{`
        .boliglaan {
          margin: 90px 0;
        }

        .boliglaan__text {
          color: var(--bgBlueish__text);
        }

        .boliglaan__text h2 {
          font-size: 52px;
          font-weight: 700;
          line-height: 0.9;
          margin: 0;
        }

        .boliglaan__text p {
          max-width: 400px;
          font-size: 24px;
          font-weight: 500;
          line-height: 1.5;
        }

        .boliglaan__features {
          padding: 1px 18px;
          margin: 54px -18px;
          background-color: var(--bgBlueish);
          border-radius: 1px;
        }

        .boliglaan__feature {
          list-style: none;
          display: flex;
          align-items: center;
          margin: 32px 0;
          color: var(--bgBlueish__text);
        }

        .boliglaan__featureIcon {
          width: 72px;
          min-width: 72px;
          height: 72px;
          margin-right: 18px;
          border-radius: 50%;
          background-color: var(--bgHotBlue);
        }

        .boliglaan__featureIcon :global(svg) {
          width: 100%;
          height: auto;
        }

        .boliglaan__featureText h3 {
          margin: 0;
          font-size: 22px;
          font-weight: 700;
        }

        .boliglaan__featureText p {
          margin: 0;
          font-size: 18px;
          font-weight: 500;
          max-width: 300px;
          line-height: 1.3;
        }

        .boliglaan__illustration {
          display: none;
        }

        @media screen and (min-width: 750px) {
          .boliglaan {
            margin: 144px 0;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: auto auto auto auto;
          }

          .boliglaan__text {
            grid-column: 1;
            grid-row: 1 / 3;
          }

          .boliglaan__text h2 {
            font-size: 82px;
          }

          .boliglaan__illustration {
            display: block;
            position: relative;
            grid-column: 2;
            grid-row: 2 / 4;
            margin: 0 -108px 0 -54px;
            background-color: var(--bgHotBlue);
            border-radius: 1px;
          }

          .boliglaan__illustration :global(svg) {
            position: absolute;
            top: -180px;
            right: 36px;
            width: 620px;
            height: auto;
          }

          .boliglaan__features {
            position: relative;
            z-index: 1;
            margin: 54px -54px 0 -108px;
            padding: 54px 54px 54px 108px;
            grid-column: 1;
            grid-row: 3 / 5;
          }

          .boliglaan__feature {
            margin: 54px 0;
          }

          .boliglaan__featureIcon {
            width: 90px;
            height: 90px;
            margin-right: 36px;
          }
        }
      `}</style>
    </div>
  );
});
